import { c as _c } from "react/compiler-runtime";
import Button from 'src/components/button/Button';
import FilterSvg from 'src/components/svg/FilterSvg';

//#region [Props]
type FilterButtonProps = {
  showFilterDialog: () => void;
  text?: string;
  className?: string;
};
//#endregion

//#region [Component]
export default function FilterButton(t0) {
  const $ = _c(7);
  const {
    showFilterDialog,
    text,
    className
  } = t0;
  const t1 = !!text;
  const t2 = text ?? "Filtrer";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FilterSvg />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== className || $[2] !== showFilterDialog || $[3] !== t1 || $[4] !== t2 || $[5] !== text) {
    t4 = <Button title={text} inverse={t1} className={className} onClick={showFilterDialog} text={t2} icon={t3} />;
    $[1] = className;
    $[2] = showFilterDialog;
    $[3] = t1;
    $[4] = t2;
    $[5] = text;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
//#endregion